/*================================================
  * 定数（グローバル変数）
================================================*/

/* 複数フォームの合計文字数上限 */
var TOTAL_LENGTH = {
    address: 32 // 配送伝票で印刷できる上限文字数
}

/* フォーム - 正規表現 */
var REGEX_PATTERNS = {
    alphaNumeric: /^[0-9a-zA-Z]*$/, // 半角英数字
    email: /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[_a-zA-Z0-9][-_a-zA-Z0-9]*\.)*(?:[a-zA-Z0-9][-a-zA-Z0-9]{0,62})\.(?:(?:[a-z]{2}\.)?[a-z]{2,})$/, // 許容判定はPHPに合わせる
    kana: /^[ァ-ヴー]*$/, // 全角カタカナ
    phoneNumber: /^[0-9][0-9-]{7,11}[0-9]$/, // 数字(1桁) 数字 or -(7~11桁) 数字(1桁)
    zipCode: /^\d{3}-\d{4}$/, // 数字(3桁)-(4桁)
    single: /^(.)\1+$/, // 同じ文字の繰り返し
    notSpaceOnly: /\S/g, // 空白文字のみの入力は許容しない
    itemQuestionAnswerCharacterTypeStandard: /^[^ｦ-ｯｱ-ﾝﾞﾟ,]+$/, // 標準の正規表現（半角カタカナ＋,以外を許容する）
    itemQuestionAnswerCharacterTypePrintableAscii: /^[\u0020-\u007E]+$/, // 半角英数字・記号
};

// 共通利用するバリデーションルール
var rule_templates = {
    kana: {
        required: true,
        pattern: REGEX_PATTERNS.kana,
        maxlength: 64
    },
    name: {
        required: true,
        pattern: REGEX_PATTERNS.notSpaceOnly,
        maxlength: 32
    },
    password: {
        required: true,
        pattern: REGEX_PATTERNS.alphaNumeric,
        rangelength: [8, 18]
    }
};

// 住所合計文字数エラー判定(addressLengthルールでエラーになっているか判定)
var isValidAddressLength = true;

// 郵便番号エラー判定(zipCodeルールでエラーになっているか判定)
var isValidZipCode = true;

// 独自のバリデーションルール
var methods = {
    // 文字種(正規表現使用)
    pattern: function(val, element, pattern) {
        return validatePattern(val, element, pattern, this);
    },
    // 同じ文字の繰り返しを非許容とする
    multiCharacter: function(val, element) {
        return !validatePattern(val, element, REGEX_PATTERNS.single, this);
    },
    // 不一致
    notEqualTo: function(val, element, param) {
        return this.optional(element) || $(param).toArray().every(elm => elm.value !== val);
    },
    // お届け先 > 住所の合計文字数
    addressLength: function(_, element) {
        var address = '';
        if ($(element).closest('.js-form').length > 0) {
            $('.js-form-address').each(function() {
                address += $(this).val();
            });
            isValidAddressLength = address.length <= TOTAL_LENGTH.address;
        }

        return isValidAddressLength;
    },
    // 日付の妥当性
    customDate: function(_, element) {
        var dateElements = $(element)
            .parent()
            .parent()
            .find('.js-form-date');
        var date = [];
        dateElements.each(function() {
            if ($(this).val()) {
                date.push($(this).val());
            }
        });
        if (date.length < dateElements.length) {
            return true;
        }
        var result = new Date(date[0], date[1] - 1, date[2]);
        return result.getFullYear() === Number(date[0]) && result.getMonth() === Number(date[1] - 1) && result.getDate() === Number(date[2]) &&
            result < new Date();
    },
    // 郵便番号の妥当性
    zipCode: function(_, element) {
        var isValid = false;
        var zipCode = '';
        $(element)
            .parent('.js-form-group')
            .find('.js-form-zipCode')
            .each(function() {
                if ($(this).val() === '') {
                    isValid = true;

                    return false;
                } else {
                    zipCode += $(this).val() + '-';
                }
            });
        // 最後の - が不要なので削除する
        zipCode = zipCode.slice(0, -1);
        // フォームのどれか1つが空欄 または 全ての郵便番号フォームに入力がありフォームの値を-で結合して正規表現とマッチする
        isValidZipCode = isValid || validatePattern(zipCode, element, REGEX_PATTERNS.zipCode, this);

        return isValidZipCode;
    }
};

/**
 * フォームに対するバリデーションルール
 *
 * 対象フォームのname属性をkeyとし、ルールを設定する
 * ルールの設定順序は 似たものがあるルール(ex.名前やパスワード) > その他アルファベット順
 * 各フォームのルール設定順序は required > 文字種 > 文字数 > その他(ex.日付妥当性)
 */
var rules = {
    // 名前(姓名)
    givenName: {
        ...rule_templates.name
    },
    familyName: {
        ...rule_templates.name
    },
    // フリガナ(姓名)
    givenNameKana: {
        ...rule_templates.kana
    },
    familyNameKana: {
        ...rule_templates.kana
    },
    // 生年月日
    'birthday[year]': {
        required: true,
        customDate: true
    },
    'birthday[month]': {
        required: true,
        customDate: true
    },
    'birthday[day]': {
        required: true,
        customDate: true
    },
    // メールアドレス
    email: {
        email: false, // patternで独自に定義しているため標準のemailバリデーションは無効化
        required: true,
        pattern: REGEX_PATTERNS.email
    },
    emailConfirm: {
        equalTo: '#newMail'
    },
    // SSCお気に入りアーティスト
    'sscFavoriteArtists[0]': {
        required: true,
    },
    'sscFavoriteArtists[1]': {},
    'sscFavoriteArtists[2]': {},
    // パスワード
    password: {
        ...rule_templates.password
    },
    oldPassword: {
        ...rule_templates.password
    },
    newPassword: {
        ...rule_templates.password,
        multiCharacter: true,
        notEqualTo: '#oldPasswordForm'
    },
    confirmPassword: {
        equalTo: '#newPasswordForm'
    },
    // 郵便番号
    'zipCode[former]': {
        required: true,
        zipCode: true
    },
    'zipCode[latter]': {
        required: true,
        zipCode: true
    },
    // 電話番号
    phoneNumber: {
        required: true,
        pattern: REGEX_PATTERNS.phoneNumber
    },
    // その他のルール(アルファベット順)
    building: {
        pattern: REGEX_PATTERNS.notSpaceOnly,
        maxlength: 16
    },
    city: {
        required: true,
        pattern: REGEX_PATTERNS.notSpaceOnly,
        addressLength: true
    },
    municipality: {
        required: function () {
            return $('select[name=pref]').children('option:selected').data('municipalityRequired') === true;
        },
        maxlength: 256
    },
    contactText: {
        required: true,
        maxlength: 1000
    },
    contactType: {
        required: true
    },
    listName: {
        required: true,
        pattern: REGEX_PATTERNS.notSpaceOnly,
        maxlength: 32,
        notEqualTo: '.js-registeredListName'
    },
    name: {
        required: true,
        pattern: REGEX_PATTERNS.notSpaceOnly,
        maxlength: 16
    },
    nameKana: {
        pattern: REGEX_PATTERNS.kana,
        maxlength: 64
    },
    newsletterFlag: {
        required: true
    },
    pref: {
        required: true,
        addressLength: true
    },
    sex: {
        required: true
    },
    street: {
        required: true,
        pattern: REGEX_PATTERNS.notSpaceOnly,
        addressLength: true
    }
};

// エラー文言のテンプレート
var error_messages_templates = {
    required: function(label) {
        return label + 'を入力してください';
    },
    minlength: function(label, min) {
        return label + 'は' + min + '文字以上で入力してください';
    },
    maxlength: function(label, max) {
        return label + 'は' + max + '文字以内で入力してください';
    },
    rangelength: function(label, min, max) {
        return label + 'は' + min + '~' + max + '文字で入力してください';
    },
    equalTo: function(label) {
        return label + 'が一致しません';
    },
    pattern: function(label, pattern) {
        if (!pattern) {
            return '正しい' + label + 'を入力してください';
        } else {
            return label + 'は' + pattern + 'で入力してください';
        }
    },
    addressLength: '都道府県、市区町村・町域、番地は合計32文字以内で入力してください'
};

// エラー文言
var error_messages = {
    givenName: {
        required: error_messages_templates.required('名(全角)'),
        pattern: error_messages_templates.pattern('名(全角)'),
        maxlength: error_messages_templates.maxlength('名(全角)', rules.givenName.maxlength)
    },
    familyName: {
        required: error_messages_templates.required('姓(全角)'),
        pattern: error_messages_templates.pattern('姓(全角)'),
        maxlength: error_messages_templates.maxlength('姓(全角)', rules.familyName.maxlength)
    },
    givenNameKana: {
        required: error_messages_templates.required('メイ(フリガナ)'),
        pattern: error_messages_templates.pattern('メイ(フリガナ)', '全角カタカナ'),
        maxlength: error_messages_templates.maxlength('メイ(フリガナ)', rules.givenNameKana.maxlength)
    },
    familyNameKana: {
        required: error_messages_templates.required('セイ(フリガナ)'),
        pattern: error_messages_templates.pattern('セイ(フリガナ)', '全角カタカナ'),
        maxlength: error_messages_templates.maxlength('セイ(フリガナ)', rules.familyNameKana.maxlength)
    },
    'birthday[year]': {
        required: error_messages_templates.required('生年月日'),
        customDate: error_messages_templates.pattern('日付')
    },
    'birthday[month]': {
        required: error_messages_templates.required('生年月日'),
        customDate: error_messages_templates.pattern('日付')
    },
    'birthday[day]': {
        required: error_messages_templates.required('生年月日'),
        customDate: error_messages_templates.pattern('日付')
    },
    email: {
        required: error_messages_templates.required('メールアドレス'),
        pattern: error_messages_templates.pattern('メールアドレス')
    },
    emailConfirm: {
        equalTo: error_messages_templates.equalTo('メールアドレス')
    },
    'sscFavoriteArtists[0]': {
        required: error_messages_templates.required('お気に入りアーティスト'),
    },
    'sscFavoriteArtists[1]': {},
    'sscFavoriteArtists[2]': {},
    password: {
        required: error_messages_templates.required('パスワード'),
        pattern: error_messages_templates.pattern('パスワード', '半角英数字'),
        rangelength: error_messages_templates.rangelength('パスワード', rules.password.rangelength[0], rules.password.rangelength[1])
    },
    oldPassword: {
        required: error_messages_templates.required('現在のパスワード'),
        pattern: error_messages_templates.pattern('現在のパスワード', '半角英数字'),
        rangelength: error_messages_templates.rangelength('パスワード', rules.password.rangelength[0], rules.password.rangelength[1])
    },
    newPassword: {
        required: error_messages_templates.required('新しいパスワード'),
        pattern: error_messages_templates.pattern('新しいパスワード', '半角英数字'),
        rangelength: error_messages_templates.rangelength('パスワード', rules.password.rangelength[0], rules.password.rangelength[1]),
        multiCharacter: 'aaaaaaaa や 11111111 などひとつの文字では設定できません',
        notEqualTo: '新しいパスワードは現在のパスワードと異なる必要があります'
    },
    confirmPassword: {
        equalTo: error_messages_templates.equalTo('パスワード')
    },
    'zipCode[former]': {
        required: error_messages_templates.required('郵便番号'),
        zipCode: error_messages_templates.pattern('郵便番号')
    },
    'zipCode[latter]': {
        required: error_messages_templates.required('郵便番号'),
        zipCode: error_messages_templates.pattern('郵便番号')
    },
    phoneNumber: {
        required: error_messages_templates.required('電話番号'),
        pattern: error_messages_templates.pattern('電話番号')
    },
    building: {
        pattern: error_messages_templates.pattern('建物名・部屋番号'),
        maxlength: error_messages_templates.maxlength('建物名・部屋番号', rules.building.maxlength)
    },
    city: {
        required: error_messages_templates.required('市区町村・町域'),
        pattern: error_messages_templates.pattern('市区町村・町域'),
        addressLength: error_messages_templates.addressLength
    },
    municipality: {
        required: error_messages_templates.required('市区町村'),
        maxlength: error_messages_templates.maxlength('市区町村', rules.municipality.maxlength)
    },
    contactText: {
        required: error_messages_templates.required('お問い合わせ内容'),
        maxlength: error_messages_templates.maxlength('お問い合わせ内容', rules.contactText.maxlength)
    },
    contactType: {
        required: error_messages_templates.required('お問い合わせ内容')
    },
    listName: {
        required: error_messages_templates.required('お届け先名称'),
        pattern: error_messages_templates.pattern('お届け先名称'),
        maxlength: error_messages_templates.maxlength('お届け先名称', rules.listName.maxlength),
        notEqualTo: 'このお届け先名称はすでに使用されています'
    },
    name: {
        required: error_messages_templates.required('お名前'),
        pattern: error_messages_templates.pattern('お名前'),
        maxlength: error_messages_templates.maxlength('お名前', rules.name.maxlength)
    },
    nameKana: {
        pattern: error_messages_templates.pattern('お名前(フリガナ)', '全角カタカナ'),
        maxlength: error_messages_templates.maxlength('お名前(フリガナ)', rules.nameKana.maxlength)
    },
    newsletterFlag: {
        required: 'メールマガジンの購読を選択してください'
    },
    pref: {
        required: error_messages_templates.required('都道府県'),
        addressLength: error_messages_templates.addressLength
    },
    sex: {
        required: '性別を選択してください'
    },
    street: {
        required: error_messages_templates.required('番地'),
        pattern: error_messages_templates.pattern('番地'),
        addressLength: error_messages_templates.addressLength
    }
};

// エラー表示箇所（id指定） 未指定の場合は{name + Error}のidを持つ要素を使用する
var error_placements = {
    'birthday[year]': 'birthdayError',
    'birthday[month]': 'birthdayError',
    'birthday[day]': 'birthdayError',
    'phoneNumber[former]': 'phoneNumberError',
    'phoneNumber[middle]': 'phoneNumberError',
    'phoneNumber[latter]': 'phoneNumberError',
    'zipCode[former]': 'zipCodeError',
    'zipCode[latter]': 'zipCodeError',
    'sscFavoriteArtists[0]': 'sscFavoriteArtistsError',
    'sscFavoriteArtists[1]': 'sscFavoriteArtistsError',
    'sscFavoriteArtists[2]': 'sscFavoriteArtistsError'
};

/*================================================
  * 即時実行関数
================================================*/

$(function() {
    // 独自のバリデーションルールを追加
    $.each(methods, function(key) {
        $.validator.addMethod(key, this);
    });

    // .js-formのselectは値を変えた時にバリデーションエラークラス&エラー文言を削除
    $('.js-form select').on('change', function() {
        if (!$(this).valid()) {
            $('.js-form-error__heading').show();
            $('.js-form-button').addClass('c-btn--disabled');
        }
    });

    // .js-form に対するバリデーション設定
    const context = $('.js-form').validate({
        rules: rules,
        messages: error_messages,
        errorClass: 'c-form__error',
        errorElement: 'p',
        groups: { // エラーメッセージをグループ化する
            birthday: 'birthday[year] birthday[month] birthday[day]',
            zipCode: 'zipCode[former] zipCode[latter]'
        },
        errorPlacement: function(error, element) {
            var elementName = element.attr('name');
            var targetId = elementName + 'Error';
            if (elementName in error_placements) {
                targetId = error_placements[elementName]; // 表示箇所に指定がある場合はそちらを使用する
            }
            var errorLabelTarget = $('#' + targetId);
            errorLabelTarget
                .empty()
                .show();
            error.appendTo(errorLabelTarget);
        },
        showErrors: function () {
            // 「都道府県」「市区町村・町域」「番地」のフォーム入力合計文字数のエラーのみ表示方法を変更する
            const invalidElement = context.errorList[0];
            if (invalidElement !== undefined && invalidElement.method === 'addressLength') {
                if (invalidElement.element.tagName === 'SELECT') {
                    $(invalidElement.element).addClass('c-form__select--error');
                } else {
                    $(invalidElement.element).addClass('c-form__textbox--error');
                }
                // 「都道府県」「市区町村・町域」「番地」フォームに対してエラークラスの付与
                $(invalidElement.element)
                    .parents('.js-form-address-section')
                    .siblings('.js-form-address-section')
                    .find('.js-form-address')
                    .each(function() {
                        if (this.tagName === 'SELECT') {
                            $(this).addClass('c-form__select--error');
                        } else {
                            $(this).addClass('c-form__textbox--error');
                        }
                    });
                // エラー文言の表示
                $('#addressLengthError')
                    .empty()
                    .append('<p class="c-form__error">' + invalidElement.message + '</p>')
                    .show();
            } else {
                context.defaultShowErrors();
            }
        },
        highlight: function(element) {
            // 要素によって付与するクラスを分ける
            if (element[0] && element[0].tagName === 'OPTION') {
                $(element).addClass('c-form__select--error');
            } else if (
                $(element).hasClass('js-form-zipCode') &&
                !isValidZipCode
            ) {
                $(element)
                    .parent('.js-form-group')
                    .find('.js-form-zipCode')
                    .addClass('c-form__textbox--error');
            } else if ($(element).hasClass('c-form__password')) {
                $(element).addClass('c-form__password--error');
            } else if ($(element).hasClass('c-form__textarea')) {
                $(element).addClass('c-form__textarea--error');
            } else {
                $(element).addClass('c-form__textbox--error');
            }
            // 都道府県、市区町村・町域、番地の合計文字数エラーの場合、バリデーションを発火させたフォーム以外のフォームにもエラークラスを付与
            if ($(element).hasClass('js-form-address') && !isValidAddressLength) {
                $(element)
                    .closest('.js-form-address-section')
                    .siblings('.js-form-address-section')
                    .find('.js-form-address')
                    .each(function() {
                        if (this.tagName === 'SELECT') {
                            $(this).addClass('c-form__select--error');
                        } else {
                            $(this).addClass('c-form__textbox--error');
                        }
                    });
            }
        },
        unhighlight: function(element) {
            // 要素によって削除するクラスを分ける
            if (element[0] && element[0].tagName === 'OPTION') {
                $(element).removeClass('c-form__select--error');
            } else if (
                $(element).hasClass('js-form-zipCode') &&
                isValidZipCode
            ) {
                var isFullInput = true;
                // 郵便番号のフォーム全てに入力がある場合のみ全てのフォームエラーを外す
                $(element)
                    .parent('.js-form-group')
                    .find('.js-form-zipCode')
                    .each(function() {
                        isFullInput = $(this).val() !== '';
                    });
                if (isFullInput) {
                    $(element)
                        .parent('.js-form-group')
                        .find('.js-form-zipCode')
                        .removeClass('c-form__textbox--error');
                }
            } else if ($(element).hasClass('c-form__password--error')) {
                $(element).removeClass('c-form__password--error');
            } else if ($(element).hasClass('c-form__textarea--error')) {
                $(element).removeClass('c-form__textarea--error');
            } else {
                $(element).removeClass('c-form__textbox--error');
            }
            // select(都道府県)の変更時はonkeyupに入らないのでここでエラークラス&エラー文言対応を行う
            if ($(element).hasClass('js-form-address') && isValidAddressLength) {
                $(element)
                    .closest('.js-form-address-section')
                    .siblings('.js-form-address-section')
                    .find('.js-form-address')
                    .each(function() {
                        if ($('#' + $(this).attr('name') + 'Error').css('display') === 'none') { // 既に表示している他のエラーがある場合はそのまま表示
                            if (this.tagName === 'SELECT') {
                                $(this).removeClass('c-form__select--error');
                            } else {
                                $(this).removeClass('c-form__textbox--error');
                            }
                        }
                    });
                // エラー文言の非表示
                $('#addressLengthError').empty().hide();
            }
            // 全フォームのバリデーションエラーがなくなった場合、ページ上部エラー文言を削除しボタンを活性化する
            if ($('.c-form__error').length === 0) {
                $('.js-form-error__heading').hide();
                $('.js-form-button').removeClass('c-btn--disabled');
            }
        },
        // 入力中はバリデーションエラークラス&エラー文言を削除
        onkeyup: function(element) {
            // 要素によって削除するクラスを分ける
            if ($(element).hasClass('c-form__password--error')) {
                $(element).removeClass('c-form__password--error');
            } else if ($(element).hasClass('c-form__textarea--error')) {
                $(element).removeClass('c-form__textarea--error');
            } else {
                $(element).removeClass('c-form__textbox--error');
            }

            var elementName = $(element).attr('name');
            var targetErrorId = elementName + 'Error';
            if (elementName in error_placements) {
                targetErrorId = error_placements[elementName]; // 表示箇所に指定がある場合はそちらを使用する
            }

            // エラー文言の非表示
            $('#' + targetErrorId)
                .empty()
                .hide();

            // 「都道府県」「市区町村・町域」「番地」合計文字数エラーのエラークラス削除&文言非表示
            if (context.settings.rules[$(element).attr('name')]?.addressLength === true) { // name属性を持たない要素（郵便番号検索ボダン等）にフォーカスが当たった際エラーになるのを防ぐためオプショナルチェーンを使用
                // エラークラスの削除
                $(element).find('.js-form-address').each(function() {
                    if ($('#' + $(this).attr('name')).css('display') === 'none') { // 既に表示している他のエラーがある場合はそのまま表示
                        if (this.tagName === 'SELECT') {
                            $(this).removeClass('c-form__select--error');
                        } else {
                            $(this).removeClass('c-form__textbox--error');
                        }
                    }
                });

                // エラー文言の非表示
                $('#addressLengthError').empty().hide();
            }
        },
        // blurで該当フォームのみバリデーション発火
        onfocusout: function(element) {
            // 送信ボタンに対しても発火するので排除する
            if ($(element)[0].tagName === 'BUTTON') {
                return;
            }
            if (!$(element).valid()) {
                $('.js-form-button').addClass('c-btn--disabled');
                $('.js-form-error__heading').show();
                if ($('.js-error__heading').css('display') === 'block') {
                    $('.js-error__heading').hide(); // PHP側のエラーを非表示にする
                }
            } else {
                var elementId = $(element).attr('id');
                // バリデーション発火したフォーム以外にもフォームを発火させる
                if (elementId === 'oldPasswordForm') {
                    validateOtherForm(element, '#newPasswordForm');
                } else if (elementId === 'newPasswordForm') {
                    validateOtherForm(element, '#confirmPasswordForm');
                } else if (elementId === 'newMail') {
                    validateOtherForm(element, '#newMailConfirm');
                }
                var isError = false;
                $('[id$="-error"]').each(function() {
                    if ($(this).css('display') !== 'none') {
                        isError = true;
                        return false;
                    }
                });
                if (!isError) {
                    if ($('.js-form-button').hasClass('c-btn--disabled')) {
                        $('.js-form-button').removeClass('c-btn--disabled');
                    }
                    $('.js-form-error__heading').hide();
                }
            }
        }
    });
});

/*================================================
  * 共通関数
================================================*/

/**
 * バリデーション発火させたフォーム以外のフォームでのバリデーション確認
 *
 * @param {object} element 発火させたフォーム
 * @param {string} otherFormId 他にバリデーション確認したいフォームのID
 */
export function validateOtherForm(element, otherFormId) {
    var $confirmForm = $(element)
        .parents()
        .find(otherFormId);
    if ($confirmForm.val() !== '' &&
        $confirmForm.valid()) {
        $('#' + $confirmForm.attr('name') + 'Error')
            .empty()
            .hide();
    }
}

/**
 * 正規表現を用いたバリデーション
 *
 * @param {string} val フォーム入力値
 * @param {object} element 該当フォーム
 * @param {object} pattern 正規表現パターン
 * @param {object} object validator(要素が存在するかの判定に使用)
 *
 * @return {boolean} true:正規表現通りの記載OK false:正規表現通りの記載NG
 */
export function validatePattern(val, element, pattern, object) {
    return object.optional(element) || new RegExp(pattern).test(val);
}

/**
 * 新規パスワードバリデーション(登録済みメールアドレスの@直前と一致する文字列は非許容)
 *
 * @param {object} $target 新規パスワード入力フォーム
 * @param {string} emailText 登録済みメールアドレス文字列
 */
export function validateNewPassword($target, emailText) {
    if ($target.val() === emailText) {
        $target.addClass('c-form__password--error');
        if ($('#newPasswordForm-error').length > 0) {
            $('#newPasswordForm-error')
                .text('パスワードにメールアドレスと同じ文字列は設定できません')
                .show();
        } else {
            $('#newPasswordError').append('<p id="newPasswordForm-error" class="c-form__error">パスワードにメールアドレスと同じ文字列は設定できません</p>');
        }
        $('#newPasswordError').show();
        $('.js-form-button').addClass('c-btn--disabled');
        $('.js-form-error__heading').show();
        if ($('.js-error__heading').css('display') === 'block') {
            $('.js-error__heading').hide(); // PHP側のエラーを非表示にする
        }
    }
}
